export enum StartLeadershipDayAndConferenceType {
  FallLeadership = 'Fall Leadership Day',
  SpringLeadershipDay = 'Spring Leadership Day',
  STARTConference = 'START Conference'
}
